export default __webpack_public_path__ + "static/media/gill-sans-light.30a3d3a9.otf";